import React from'react'
import { Progress,Row,Col } from 'antd';

const Tasks =()=>{
    return(
        <>
        <Row justify="space-around" align="middle" >
        
            <Col > 
            <h3 className="align-text-center">Attendence</h3>
            <Progress type="circle" percent={75} />
             </Col>
            <Col >
            <h3>Messages</h3>
                <Progress type="circle"
                 status="plain" 
                 percent={75} format={() => '75'}  /></Col>
            <Col >
            <h3>Pending Tasks</h3>
                 <Progress type="circle" percent={100} /></Col>
       
           
            
        </Row>
     
     
     
      </>

    )
}
export default Tasks
 